// extracted by mini-css-extract-plugin
module.exports = {"lobby":"LobbyPage_lobby__2VQ3d"};